import { Combobox as ComboboxPrimitive } from '@base-ui/react/combobox';

import { useComboboxContext } from '@/components/Form/pickers/primitives/combobox/ComboboxContext';
import { cn } from '@/lib/utils';

export type ComboboxChipsInputProps = ComboboxPrimitive.Input.Props;

const ComboboxChipsInput = ({ className, ...props }: ComboboxChipsInputProps) => {
  const { disabled = false } = useComboboxContext();

  return (
    <ComboboxPrimitive.Input
      data-slot="combobox-chip-input"
      className={cn(
        'min-w-16 flex-1 outline-none placeholder:text-gray-500',
        'disabled:cursor-not-allowed disabled:text-gray-400! disabled:placeholder:text-gray-400',
        className,
      )}
      disabled={disabled}
      {...props}
    />
  );
};

export default ComboboxChipsInput;
